import {ClickEvent} from "../../../../infrastructure/models/analytics/click-event";

export class NewSearchWidgetClearEvent extends ClickEvent {
  source: String;

  constructor(params) {
    super('click', 'clear-recent', 'search-tool');
    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;

    return properties;
  }
}